module.exports = __webpack_public_path__ + "img/mulanlogo.57a157ab.png";